<template>
	<div class="wrap">
		<van-nav-bar
			:title="title"
			@click-left="clickNavBack"
			left-arrow
			id="reset"
			:border="false"
		></van-nav-bar>
		<div style="margin: 20px;padding: 8px;border-radius: 10px;background-color: #f5f5f5;" v-if="topicList.length > 0">
			<van-cell-group title="错题集已按知识点归类" inset style="margin-bottom: 15px">
				<van-cell v-for="item in topicList" :key="item.knowledgeId" :title="item.knowledgeName" icon="failure" is-link :value="'共' + item.questionTotal + '题'" @click="topicView(item.questionIds)" />
			</van-cell-group>
		</div>
		<van-empty description="优秀！您没有错题记录！" v-else />
	</div>
</template>

<script>
import {getQuestionWrongBooks} from "@/api/user";

export default {
	name: "vipwbook",
	data() {
		return {
			title: '错题集',
			topicList: []
		}
	},
	computed: {
		studentId() {
			return JSON.parse(localStorage.getItem('loginInTKfor_APP02')) === null ? '' : JSON.parse(localStorage.getItem('loginInTKfor_APP02')).studentId
		},
		issubject() {
			return this.$route.query.subject
		},
		categoryId() {
			return this.$route.query.categoryId
		},
		appNo() {
			return JSON.parse(localStorage.getItem('loginInTKfor_APP02')) === null ? '' : sessionStorage.getItem('appno') || 'APP02'
		},
	},
	created() {
		this.loadTopicList();
	},
	methods: {
		// 点击回退
		clickNavBack() {
			this.$router.go(-1);
		},
		// 加载知识点统计错题集
		loadTopicList() {
			getQuestionWrongBooks(
				this.studentId,
				this.categoryId,
				this.issubject
			).then(res => {
				this.topicList = res;
			});
		},
		// 打开错题集
		topicView(questionIds) {
			sessionStorage.setItem('wrongbook', JSON.stringify({ExercisesId: questionIds}));
			this.$router.push({
				path: '/vipwbooklist',
				query: { subject: this.issubject, categoryId: this.categoryId, appNo: this.appNo }
			})
		}
	}
}
</script>

<style scoped lang="less">
.van-nav-bar {
	background-color: #2db1ac !important;
}

::v-deep .van-nav-bar .van-icon {
	color: #fff;
}

::v-deep .van-ellipsis {
	color: #fff;
}

.wrap {
	position: relative;
}

.secret-wrap {
	width: 100%;
	height: 100vh;
	background: url('../../assets/vip/secret-bj2.png') no-repeat;
	background-size: 100% 100%;
	background-position: center center;
	overflow: auto;
	position: absolute;
	top: 0;
	left: 0;
	padding: 0 5%;

	.secret-topics {
		margin-top: 40vh;
		display: flex;
		justify-content: space-around;

		.secret-ques {
			width: 45%;
			height: 120px;
			margin: 30px auto;
			background-color: transparent;
			border: 2px solid red;
			position: relative;

			.ques-name {
				width: 100%;
				height: 50px;
				text-align: center;
				background-color: #ff000080;
				color: #fff;
				line-height: 20px;
				padding-top: 15px;
				font-size: 16px;
				font-weight: 800;
			}

			.ques-btn {
				text-align: center;
				margin-top: 15px;

				.ques-button {
					width: 80px;
					height: 30px;
					background: linear-gradient(to bottom, #FF450080, #ff000090);
					color: #fff;
					animation: myfirst 2s;
					-webkit-animation: myfirst 2s;
					animation-iteration-count: 99999;
					-webkit-animation-iteration-count: 99999;
				}

				@keyframes myfirst {
					0% {
						transform: scale(1);
						box-shadow: -2px 2px 3px #00000080;
					}
					100% {
						transform: scale(1.3);
						box-shadow: -2px 2px 3px #00000080;
					}
				}
				@-webkit-keyframes myfirst {
					0% {
						transform: scale(1);
						box-shadow: -2px 2px 3px #00000080;
					}
					100% {
						transform: scale(1.3);
						box-shadow: -2px 2px 3px #00000080;
					}
				}
			}
		}
	}
}

.page-body {
	height: 100%;
	margin-top: 0;
	padding: 20px 0 15px;

	.content {
		position: relative;
		top: -14px;
		background: #fff;
		border-radius: 14px;
		padding: 20px 15px 35px;

		.section-title {
			display: flex;
			margin-bottom: 12px;

			.status {
				flex-shrink: 0;
				margin-right: 6px;
			}

			.title-style {
				display: inline-block;
				margin-top: 2px;
				padding: 2px 6px;
				background: linear-gradient(90deg, #2db1ac, #2db1ac);
				border-radius: 17px;
				color: #fbf9f8;
				font-size: 11px;
			}

			.title-txt {
				font-size: 15px;
				color: #444444;
				line-height: 1.8;
			}
		}

		.section-img {
			margin-bottom: 10px;

			img {
				width: 100%;
			}
		}

		.section-options {
			margin-bottom: 40px;

			.option-item {
				margin-bottom: 12px;
				color: #444444;

				.letter {
					display: inline-block;
					width: 20px;
					height: 20px;
					line-height: 20px;
					text-align: center;
					font-size: 13px;
					box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
					margin-right: 8px;
					border-radius: 20px;
				}

				.letters {
					display: inline-block;
					width: 20px;
					height: 20px;
					line-height: 20px;
					text-align: center;
					font-size: 13px;
					box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
					margin-right: 8px;
					border-radius: 20px;
					color: #fff;
					background: #2db1ac;
				}

				&.active {
					.letter {
						color: #fff;
						background: #2db1ac;
					}
				}

				.letteres {
					display: inline-block;
					width: 20px;
					height: 20px;
					line-height: 20px;
					text-align: center;
					font-size: 13px;
					box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
					margin-right: 8px;
					border-radius: 20px;
					color: #fff;
					background: #2db1ac;
				}
			}

			.van-radio {
				margin: 10px 0;
			}
		}

		.determine {
			background-color: #2db1ac;
		}

		.btn-wrap {
			display: flex;
			justify-content: flex-end;
			margin: 40px 0 0;

			.btn {
				width: 70px;
				padding: 0;
				height: 30px;
				font-size: 14px;
				margin: 0 10px 0 0;
				color: #fff;
				background: linear-gradient(90deg, #2db1ac, #2db1ac);
				border-radius: 40px;
				border: 1px solid #2db1ac;
			}

			.btn .default {
				background: #ffffff;
				color: #2db1ac;
				border: 1px solid #2db1ac;
			}
		}

		.section-desc {
			display: flex;
			justify-content: space-between;
			position: fixed;
			bottom: 0;
			width: 100%;
			height: 60px;
			left: 0;
			padding: 0 20px;
			line-height: 60px;
			border-top: 1px solid #e1e1e1;
			background: #ffffff;
			z-index: 10;

			img {
				width: 20px;
				margin-right: 8px;
			}

			.left {
				display: flex;
				align-items: center;
			}

			.left-wrap {
				display: flex;
				position: absolute;
				left: 100px;
			}

			.right-wrap {
				display: flex;
				position: absolute;
				right: 10px;
				top: 0;
			}

			.right {
				display: flex;
				align-items: center;
				margin-right: 12px;

				&.right-answer {
					color: #2db1ac;
				}

				&.wrong-answer {
					color: #ff1a1a;
				}

				&.favorites {
					color: #FAAB0C;
				}

				.van-icon {
					color: #000;
				}
			}
		}
	}
}

.panel-wrap {
	width: 100%;

	.wrong {
		height: 50px;
		text-align: center;
		color: red;
		line-height: 50px;
		font-size: 16px;
	}

	.iswrong {
		height: 50px;
		text-align: center;
		color: #2db1ac;
		line-height: 50px;
		font-size: 16px;
	}

	.right-key {
		width: 90%;
		height: 50px;
		line-height: 50px;
		font-size: 18px;
		font-weight: bolder;
		margin-left: 5%;
		border-bottom: 1px solid #000;

		.seen {
			color: #2db1ac;
		}

		.unseen {
			display: none;
		}
	}

	.problem {
		line-height: 30px;
		padding-left: 5%;
		font-weight: bold;
		font-size: 14px;

		.tip {
			font-weight: normal;
			font-size: 12px;
			line-height: 20px;
			padding-right: 5%;
			padding-left: 0;
		}
	}

	.explain-detai {
		width: 90%;
		height: 50px;
		line-height: 50px;
		font-size: 18px;
		font-weight: bolder;
		margin-left: 5%;
		border-bottom: 1px solid #000;
	}

	.video-analysis {
		line-height: 40px;
		padding-left: 5%;
		font-weight: bold;
		font-size: 14px;

		.video-wrap {
			width: 95%;
			height: 210px;
			border: 1px solid red;
		}
	}

	.topic-analysis {
		line-height: 40px;
		padding-left: 5%;
		font-weight: bold;
		font-size: 14px;
		margin-bottom: 20%;

		.tip {
			font-weight: normal;
			font-size: 12px;
			line-height: 20px;
			padding-right: 5%;
			padding-left: 0;
		}

		.difficulty {
			line-height: 30px;
			color: #2db1ac;
			font-size: 14px;
			font-weight: normal;
		}
	}
}

.popup-wrap {
	.section-desc {
		display: flex;
		justify-content: space-between;
		width: 100%;
		height: 60px;
		left: 0;
		padding: 0 20px;
		line-height: 60px;
		border-top: 1px solid #E1E1E1;
		background: #ffffff;
		z-index: 10;

		img {
			width: 20px;
			margin-right: 8px;
		}

		.left {
			display: flex;
			align-items: center;
		}

		.right-wrap {
			display: flex;
		}

		.right {
			display: flex;
			align-items: center;
			margin-right: 12px;

			&.right-answer {
				color: #2db1ac;
			}

			&.wrong-answer {
				color: #FF1A1A;
			}

			&.favorites {
				color: #FAAB0C;
			}

			.van-icon {
				color: #000;
			}
		}
	}

	.section-cicle {
		padding: 0 16px;

		.cicle-index {
			display: inline-block;
			width: 40px;
			height: 40px;
			background: #FFFFFF;
			border: 1px solid #AAAAAA;
			border-radius: 50%;
			margin-right: 8px;
			margin-bottom: 8px;
			text-align: center;
			line-height: 40px;
			color: #666;

			&.active {
				background: #FFA500;
				color: #ffffff;
				border-color: transparent;
			}
		}

		.cicle-correct {
			background: #2db1ac;
		}

		.cicle-error {
			background: #FF0000;
		}
	}
}

.popup-content {
	width: 290px;
	overflow: hidden;
	background: #fff;

	& > .title {
		background: linear-gradient(90deg, #2db1ac, #2db1ac);
		padding: 15px;
		font-size: 18px;
		color: #fff;
		text-align: center;
	}

	.content {
		margin: 20px 0 10px;
		padding: 0 10px;
		font-size: 17px;
		text-align: center;

		.list {
			display: flex;
			align-items: center;
			margin-top: 10px;

			span {
				display: inline-block;
				width: 50%;
			}
		}
	}

	.btn-wrap {
		display: flex;
		padding: 15px;

		.btn {
			width: 40%;
			font-weight: 500;
		}
	}
}
</style>
